module.exports = __webpack_public_path__ + "static/media/corpu_desc_img1.31c4252b.jpg";